<template>
  <div class="navigation">
    <div class="navigation-left">
      <Logo></Logo>
    </div>
    <div class="navigation-right" v-if="this.userAgent.window.width < 1024 && this.$route.name !== 'Home'">
      <div class="progress_mobile">
        <span class="progress_mobile_text" v-html="aSection + '/' + this.returnSectionsCount"></span>
      </div>
      <div class="progress_video" @click="toggleModal('modal-video')">
        <div class="progress_video-content">
          <a href="javascript:void(0)" @click.prevent class="progress-button unselectable">EXPERT’S<br/>OPINION</a>
        </div>
      </div>
      <div :class="['burger_wrapper', {'burger--open' : this.isMenuActive}]" @click="toggleMobileMenu()">
        <div class="burger_toggle">
          <span class="burger_toggle--line line_1"></span>
          <span class="burger_toggle--line line_2"></span>
          <span class="burger_toggle--line line_3"></span>
        </div>
      </div>
    </div>
    <div class="nav_wrapper" v-if="this.userAgent.window.width < 1024" :class="{'nav_wrapper--open': this.isMenuActive}">
      <div class="patient_navigation" v-for="(item, index) in this.routes" :key="index" :id="'route-link__' + index" @click="onSelectItem(item.to)">
        <div class="patient_router-case">
          <div class="patient_router-case-left">
            <div class="patient_router-case__image">
              <img alt :src="item.image" class="router-case_image">
            </div>
            <div class="patient_router-case__text">
              <p v-html="item.name + '<sup>*</sup>'" class="router-case_name"></p>
              <p v-html="item.description" class="router-case_description"></p>
            </div>
          </div>
          <div class="patient_router-case-right">
            <div class="patient_router-case__doc">
              <img alt :src="item.kol" class="router-case_doc" :class="['router-case_doc--' + index]">
            </div>
          </div>
        </div>
      </div>
      <p class="menu-footnote"><span class="ml-5">*</span>Patients cases based on physician experience,<br>not actual patients.</p>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo/Logo';
import { mapState } from 'vuex';

export default {
  name: 'MainNavigation',
  data() {
    return {};
  },
  components: {
    Logo
  },
  computed: {
    returnSectionsCount() {
      if (this.$route.name !== 'Gabrielle') {
        return '06'
      } else {
        return '05'
      }
    },
    ...mapState([
      'userAgent', 'isMenuActive', 'patients', 'urls', 'routes', 'isAdditionalActive'
    ]),
    ...mapState({
      aSection: state => state.currentSection.id
    }),
  },
  methods: {
    toggleModal(target) {
      let targetVideo = this.$parent.$refs[target];
      targetVideo.open();
    },
    modalClose() {},
    onSelectItem(slug) {
      if (this.$route.path === slug) {
        this.toggleMobileMenu();
        return true;
      }
      this.toggleMobileMenu();
      this.$router.push(slug);
    },
    toggleMobileMenu() {
      this.isMenuActive ? this.$store.commit('TOGGLE_MENU_STATUS', false) : this.$store.commit('TOGGLE_MENU_STATUS', true);
      //
      if (this.isAdditionalActive) {
        this.$store.commit('TOGGLE_ADDITIONAL_STATUS', false);
      }
    },
    toggleVideo() {
      this.$store.commit('TOGGLE_VIDEO', true);
    }
  },
  mounted() {
  },
  watch: {}
};
</script>

<style lang="scss">
.navigation {
  display: flex;
  position: absolute;
  flex-direction: row;
  width: 100%;
  height: 66px;
  background-color: #e4e6e8;
  z-index: 9999;
  padding: 0 20px;

  @include media("<tablet") {
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .navigation-left {
    display: flex;
    flex-direction: column;
    width: 50%;
    @include media("<=500px") {
      width: 45%;
    }
    @include media("<=360px") {
      width: 40%;
    }
  }

  .navigation-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 50%;
    height: 100%;
    @include media("<=500px") {
      width: 55%;
    }
    @include media("<=360px") {
      width: 60%;
    }
  }
}

.progress_mobile {
  @include media("<tablet") {
    display: flex;
    flex-direction: column;
  }

  &_text {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1c3460;
  }
}

.progress_video {
  display: flex;
  flex-direction: column;
  cursor: pointer;

  .progress_video-content {
    border-radius: 5px;
    background-color: #1c3460;
    padding: 5px 10px;
  }
}

.progress-button {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  //
  text-decoration: none;
}

.burger_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;

  .burger_toggle {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;

    &--line {
      background-color: #1c3460;
      display: block;
      width: 24px;
      height: 2px;
      margin-bottom: 5px;
      transition: all 200ms;
    }
  }

  &.burger--open {
    .line_1 {
      transform: rotate(45deg) translate3d(6px, 3px, 0);
      transition: all 200ms;
      margin-bottom: 5.6px;
    }

    .line_2 {
      transform: rotate(-45deg) translate3d(2px, 0px, 0);
      transition: all 200ms;
    }

    .line_3 {
      transition: all 20ms;
      opacity: 0;
    }
  }
}

.nav_wrapper {
  @include media("<tablet") {
    position: fixed;
    top: 104px;
    right: 0;
    left: 0;
    width: 100%;
    padding-top: 0;
    background: $accent;
    height: 310px;
    min-height: 110px;
    max-height: 390px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
    &:after {
      content: '';
      width: 100%;
      height: 100vh;
      position: absolute;
      top: 310px;
      opacity: 0.75;
      background-color: #1c3460;
      left: 0;
      right: 0;
      display: block;
      z-index: 0;
      @include media("<=320px") {
        content: none;
      }
    }
    &--open {
      opacity: 1;
      pointer-events: all;
      transition: opacity 0.3s;
      z-index: 10000;
    }
  }
  @include media("<phone") {
    height: 360px;
    &:after {
      top: 360px;
    }
  }
  @include media("<=320px") {
    height: 310px;
    overflow: scroll;
    padding-bottom: 20px;
  }
}

.menu_link {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  padding: 5px 20px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @include media("<tablet") {
    display: block;
    width: 100%;
    color: #fff;
  }
}

.patient_navigation {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  padding: 10px 0 10px 20px;
  text-decoration: none;
  cursor: pointer;

  .patient_router-case {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
    align-items: flex-end;
    justify-content: space-between;
    //
    border-bottom: solid 1px rgba(255, 255, 255, 0.46);

    &-left {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;

      .patient_router-case__image {
        display: flex;
        flex-direction: column;
      }

      .patient_router-case__text {
        display: flex;
        flex-direction: column;
        padding: 0 15px 10px 15px;
      }

      @include media("<tablet") {
        margin-bottom: 10px;
      }
      @include media("<phone") {
        margin-bottom: 0;
      }
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-right: 10px;

      .patient_router-case__doc {
        display: flex;
        flex-direction: column;
      }
    }
  }

  @include media("<=330px") {
    padding: 5px 0 5px 20px;
  }
}

.router-case_image {
  width: 56px;
  height: 56px;
}

.router-case_name {
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #ffffff;
  //
  text-transform: uppercase;
}

.router-case_description {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 10px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #ffffff;
}

.router-case_doc {
  display: flex;
  flex-direction: column;

  &--0 {
    width: 53.8px;
    height: 55px;
  }

  &--1 {
    width: 61.9px;
    height: 57.5px;
  }

  &--2 {
    width: 63.1px;
    height: 58.4px;
  }
}

#route-link__0 {
  padding-top: 10px;
}

#route-link__2 {
  padding-bottom: 0;
}

.menu-footnote {
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #ffffff;
  padding: 10px 20px 0 23px;
}
</style>
